import { r4Client, r4Error } from '@/services'

const ReportsApi = {
  /**
   * Create data to generate a report
   * @param {Object} reportParams
   */
  async generateReport (reportParams) {
    try {
      const resp = await r4Client().post('/api/v1/query_engine/reports', reportParams)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default ReportsApi
